import script from "./DashboardStatsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardStatsSection.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardStatsSection.vue?vue&type=style&index=0&id=770e52c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770e52c4"]])

export default __exports__